module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "interest-search"
    }
  }, [(_vm.currentArea) ? _c('div', {
    staticClass: "ds-main ds-border",
    class: {
      'show-majors': _vm.selected
    },
    attrs: {
      "id": "carousel"
    }
  }, [_c('img', {
    staticClass: "slide-img",
    attrs: {
      "src": _vm.currentArea.large_image_url
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.previousArea
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "slide-info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.currentArea.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.currentArea.definition))]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.selected = true
      }
    }
  }, [_vm._v("See " + _vm._s(_vm.programNaming))])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.nextArea
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "carousel-swiper"
    }
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "options": _vm.swiperOptions,
      "not-next-tick": _vm.notNextTick
    }
  }, _vm._l((_vm.interestAreas), function(area, i) {
    return _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "swiper-content ds-main ds-border",
      class: {
        'current-area': area === _vm.currentArea
      },
      on: {
        "click": function($event) {
          return _vm.swiperClick(area, i)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "swiper-img",
      attrs: {
        "src": area.large_image_url
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "swiper-img",
      attrs: {
        "src": area.medium_image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-title"
    }, [_vm._v("\n              " + _vm._s(area.name) + "\n            ")])])])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "carousel-back"
    }
  }, [(_vm.selected) ? _c('div', {
    staticClass: "carousel-back ds-main ds-background",
    on: {
      "click": function($event) {
        _vm.selected = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected) ? _c('div', {
    attrs: {
      "id": "interest-majors"
    }
  }, [_c('major-list', {
    attrs: {
      "majors": _vm.currentMajors
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a8edf8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/InterestSearch.vue
// module id = 999
// module chunks = 1